export enum IInvoicesAgeAnalysisSelectFilter {
    AccountNumber,
    DebtorNumber,
    DebtorName,
}